import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".image-library--1pa50 {\n  border-radius: 0.3rem;\n}\n.image-library--1pa50 .landscape-library--gbaAa,\n.image-library--1pa50 .portrait-library--JJKmp {\n  position: relative;\n}\n.image-library--1pa50 .landscape-library--gbaAa {\n  padding-top: 75%;\n}\n.image-library--1pa50 .portrait-library--JJKmp {\n  padding-top: 133.3333%;\n}";
var styles = {"image":"image-library--1pa50","landscape":"landscape-library--gbaAa","portrait":"portrait-library--JJKmp"};
styleInject(css_248z);

export { styles as default };
